export default "__VITE_ASSET__DS_lOnwm__"